import { gql } from '@apollo/client';

export interface Plan_UserPlan {
  employerId: string;
  plan: Plan_Plan;
}

export interface Plan_Plan {
  id: string;
  products: Plan_ProductSet;
}

export interface Plan_ProductSet {
  tuitionAssistance?: Plan_Product;
  tuitionReimbursement?: Plan_Product;
  sponsorship?: Plan_Product;
  studentLoan?: Plan_Product;
  jobResources?: Plan_Product;
}

export interface Plan_ProductAttributes {
  optimizationAvailable: boolean;
  reimbursementAvailable: boolean;
}

export interface Plan_CoveredExpenses {
  expenseTypeId: string;
}

export interface Plan_FundingPackage {
  coveredExpenses?: Plan_CoveredExpenses[];
}

export interface Plan_Product {
  id: string;
  available: boolean;
  programs: Plan_EligibleProgram[];
  fundingPackages: Plan_FundingPackage[];
  attributes?: Plan_ProductAttributes;
}

export interface Plan_EligibleProgram {
  programId: string;
}

export interface UserPlanResponse {
  userPlan: Plan_UserPlan;
}

export interface UserPlanVariables {
  employerId: string;
  userId: string;
}

export interface MemberPlan {
  hasTuitionAssistance?: boolean;
  hasTuitionReimbursement?: boolean;
  hasSponsorship?: boolean;
  hasTuitionReimbursementOnly?: boolean;
  hasNoCoverage?: boolean;
  hasBooksAndFees?: boolean;
  hasStudentLoanOptimization?: boolean;
  hasStudentLoanReimbursement?: boolean;
  hasCareerAccelerator?: boolean;
  hasCoveredExpenses?: boolean;
}

export const BOOKS_AND_FEES_ID = 'ea2c9567-4c57-4a1b-be28-16935f23ecfb';

export const USER_PLAN_QUERY = gql`
  query USER_PLAN($employerId: ID!, $userId: ID) {
    userPlan: plan_getUserPlan(employerId: $employerId, userId: $userId) {
      employerId
      plan {
        id
        products {
          jobResources {
            available
          }
          tuitionAssistance {
            id
            available
            programs {
              programId
            }
            fundingPackages {
              coveredExpenses {
                expenseTypeId
              }
            }
          }
          tuitionReimbursement {
            id
            available
            programs {
              programId
            }
            fundingPackages {
              coveredExpenses {
                expenseTypeId
              }
            }
          }
          sponsorship {
            id
            available
            programs {
              programId
            }
            fundingPackages {
              coveredExpenses {
                expenseTypeId
              }
            }
          }
          studentLoan {
            id
            available
            attributes {
              optimizationAvailable
              reimbursementAvailable
            }
          }
        }
      }
    }
  }
`;
